'use strict';

/* Wiring for the "Load more" button, shared by the collection and search
   templates. They pass different container selectors because the two templates
   put id="product-grid" on different elements: the <ul> on collection, the
   wrapping <div> on search. snippets/pb-grid-fit-sort works around the same asymmetry. */
window.initLoadMore = function initLoadMore(options) {
  var instances = (window.loadMoreInstances = window.loadMoreInstances || {});
  var key = options.key;

  function build() {
    var existing = instances[key];
    if (existing && typeof existing.destroy === 'function') {
      try {
        existing.destroy();
      } catch (error) {
        /* The previous instance was already detached, nothing to unbind. */
      }
    }

    if (!document.querySelector(options.container)) return;

    instances[key] = new Ajaxinate({
      container: options.container,
      pagination: options.pagination || '.infinite_next',
      method: 'click',
      loadingText: options.loadingText,
    });
  }

  build();
  window.loadMoreReserveOptions = options;
  bindReserve();

  /* facets.js rebuilds the whole of #ProductGridContainer on every filter or
     sort change, which detaches the nodes Ajaxinate is bound to. Inline scripts
     do not re-run on an innerHTML assignment, so rebind here instead.
     childList without subtree is deliberate: #ProductGridContainer has a single
     direct child, and Ajaxinate appends deeper than that, so its own work will
     not retrigger this. */
  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer && !gridContainer.dataset.loadMoreObserver) {
    gridContainer.dataset.loadMoreObserver = 'true';
    new MutationObserver(build).observe(gridContainer, { childList: true });
  }
};

/* Layout shift guard. The next page arrives well over 500 ms after the tap, so
   when Ajaxinate appended it, everything under the grid (the button, footer,
   Klaviyo block) jumped down and counted as layout shift: one tap scored ~0.4
   CLS on mobile. Growing the grid by the expected height in the tap itself makes
   that move part of the interaction (which CLS ignores); the cards then fill
   space that is already there. Any estimation error only moves content that has
   already been pushed below the fold. */
function bindReserve() {
  if (window.loadMoreReserveBound) return;
  window.loadMoreReserveBound = true;

  document.addEventListener(
    'click',
    function (event) {
      var options = window.loadMoreReserveOptions;
      if (!options || !event.target.closest) return;
      var trigger = event.target.closest('.pagination-wrapper--load-more ' + (options.pagination || '.infinite_next'));
      if (trigger) reserveNextPage(options);
    },
    true
  );
}

function reserveNextPage(options) {
  var container = document.querySelector(options.container);
  var wrapper = document.querySelector('.pagination-wrapper--load-more');
  if (!container || !wrapper || container.dataset.loadMoreReserved) return;

  var items = container.querySelectorAll('.grid__item');
  var total = parseInt(wrapper.dataset.items, 10);
  var pageSize = parseInt(wrapper.dataset.pageSize, 10);
  if (!items.length || !total || !pageSize) return;

  var incoming = Math.min(pageSize, total - items.length);
  if (incoming <= 0) return;

  var firstTop = items[0].offsetTop;
  var columns = 0;
  while (columns < items.length && items[columns].offsetTop === firstTop) columns++;
  var lastTop = items[items.length - 1].offsetTop;
  var rows = Math.round((lastTop - firstTop) / Math.max(items[0].offsetHeight, 1)) + 1;
  var rowHeight = rows > 1 ? (lastTop - firstTop) / (rows - 1) : items[0].offsetHeight;
  var extra = Math.ceil(incoming / Math.max(columns, 1)) * rowHeight;

  container.dataset.loadMoreReserved = 'true';
  // The grid is a wrapping flex list; without this the spare height would be
  // shared out between the existing rows and stretch them.
  container.style.alignContent = 'flex-start';
  container.style.minHeight = Math.round(container.offsetHeight + extra) + 'px';

  var before = items.length;
  var release = function () {
    observer.disconnect();
    clearTimeout(timer);
    container.style.minHeight = '';
    container.style.alignContent = '';
    delete container.dataset.loadMoreReserved;
  };
  var observer = new MutationObserver(function () {
    if (container.querySelectorAll('.grid__item').length > before) requestAnimationFrame(release);
  });
  observer.observe(container, { childList: true, subtree: true });
  // A failed request never appends anything; do not leave the gap behind.
  var timer = setTimeout(release, 15000);
}
